if (!customElements.get('multi-add-to-cart')) {
  class MultiAddToCart extends HTMLElement {
    constructor() {
      super();
      this.cards = this.querySelectorAll('[data-multi-add-card]');
      this.totalEl = this.querySelector('[data-multi-add-total]');
      this.feetEl = this.querySelector('[data-multi-add-feet]');
      this.feetLine = this.querySelector('[data-multi-add-feet-line]');
      this.perUnitEl = this.querySelector('[data-multi-add-per-unit]');
      this.perUnitLine = this.querySelector('[data-multi-add-per-unit-line]');
      this.button = this.querySelector('[data-multi-add-button]');
      this.buttonText = this.querySelector('[data-multi-add-button-text]');
      this.spinner = this.querySelector('[data-multi-add-spinner]');
      this.errorEl = this.querySelector('[data-multi-add-error]');
      this.moneyFormat = window.Shopify?.locale === 'en' ? '${{amount}}' : '${{amount}}';
    }

    connectedCallback() {
      this.cards.forEach((card) => {
        const minusBtn = card.querySelector('[data-qty-minus]');
        const plusBtn = card.querySelector('[data-qty-plus]');
        const input = card.querySelector('[data-qty-input]');

        minusBtn?.addEventListener('click', () => {
          const current = parseInt(input.value) || 0;
          if (current > 0) {
            input.value = current - 1;
            this.onQuantityChange(card);
          }
        });

        plusBtn?.addEventListener('click', () => {
          const current = parseInt(input.value) || 0;
          input.value = current + 1;
          this.onQuantityChange(card);
        });

        input?.addEventListener('change', () => {
          let val = parseInt(input.value) || 0;
          if (val < 0) val = 0;
          input.value = val;
          this.onQuantityChange(card);
        });
      });

      this.button?.addEventListener('click', () => this.addToCart());
      this.updateSummary();
    }

    onQuantityChange(card) {
      const qty = parseInt(card.querySelector('[data-qty-input]').value) || 0;
      if (qty > 0) {
        card.classList.add('variant-cards__card--active');
      } else {
        card.classList.remove('variant-cards__card--active');
      }
      this.updateSummary();
    }

    getItems() {
      const items = [];
      this.cards.forEach((card) => {
        const qty = parseInt(card.querySelector('[data-qty-input]').value) || 0;
        if (qty > 0 && card.dataset.variantAvailable === 'true') {
          items.push({
            id: parseInt(card.dataset.variantId),
            quantity: qty,
            price: parseInt(card.dataset.variantPrice),
            size: parseFloat(card.dataset.variantSize) || 0,
          });
        }
      });
      return items;
    }

    updateSummary() {
      const items = this.getItems();
      let totalPrice = 0;
      let totalSize = 0;

      items.forEach((item) => {
        totalPrice += item.price * item.quantity;
        totalSize += item.size * item.quantity;
      });

      if (this.totalEl) {
        this.totalEl.textContent = this.formatMoney(totalPrice);
      }

      if (this.feetLine) {
        if (totalSize > 0) {
          this.feetEl.textContent = totalSize % 1 === 0 ? totalSize + ' ft' : totalSize.toFixed(1) + ' ft';
          this.feetLine.style.display = '';
        } else {
          this.feetLine.style.display = 'none';
        }
      }

      if (this.perUnitLine) {
        if (totalSize > 0 && totalPrice > 0) {
          const pricePerUnit = Math.round(totalPrice / totalSize);
          this.perUnitEl.textContent = this.formatMoney(pricePerUnit) + '/ft';
          this.perUnitLine.style.display = '';
        } else {
          this.perUnitLine.style.display = 'none';
        }
      }

      const totalQty = items.reduce((sum, item) => sum + item.quantity, 0);
      if (this.button) {
        this.button.disabled = totalQty === 0;
      }
      if (this.buttonText) {
        this.buttonText.textContent =
          totalQty > 0 ? `Add ${totalQty} item${totalQty > 1 ? 's' : ''} to Cart` : 'Add to Cart';
      }
    }

    formatMoney(cents) {
      const amount = (cents / 100).toFixed(2);
      return '$' + amount;
    }

    async addToCart() {
      const items = this.getItems();
      if (items.length === 0) return;

      this.button.disabled = true;
      this.spinner?.classList.remove('hidden');
      this.buttonText?.classList.add('hidden');
      this.errorEl?.classList.add('hidden');

      const body = {
        items: items.map((item) => ({
          id: item.id,
          quantity: item.quantity,
        })),
      };

      try {
        const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body),
        });

        if (!response.ok) {
          const error = await response.json();
          throw new Error(error.description || error.message || 'Could not add items to cart');
        }

        // Publish cart update event for other components
        if (typeof publish === 'function') {
          publish(PUB_SUB_EVENTS.cartUpdate, {});
        }

        // Reset quantities
        this.cards.forEach((card) => {
          const input = card.querySelector('[data-qty-input]');
          if (input) input.value = 0;
          card.classList.remove('variant-cards__card--active');
        });
        this.updateSummary();

        // Open cart drawer if it exists, using its built-in renderContents method
        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
          // Remove is-empty from cart-drawer so open() finds the right container
          cartDrawer.classList.remove('is-empty');
          const sectionsResponse = await fetch(
            window.Shopify.routes.root + '?sections=cart-drawer,cart-icon-bubble'
          );
          if (sectionsResponse.ok) {
            const sections = await sectionsResponse.json();
            cartDrawer.renderContents({ sections });
          }
        }
      } catch (error) {
        if (this.errorEl) {
          this.errorEl.textContent = error.message;
          this.errorEl.classList.remove('hidden');
        }
      } finally {
        this.spinner?.classList.add('hidden');
        this.buttonText?.classList.remove('hidden');
        this.button.disabled = false;
        this.updateSummary();
      }
    }
  }

  customElements.define('multi-add-to-cart', MultiAddToCart);
}
